import React from 'react'
import { Tabs, Tab, BottomNavigation, BottomNavigationAction, useMediaQuery } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import HomeIcon from '@mui/icons-material/Home'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import RoomIcon from '@mui/icons-material/Room'
import AddHomeIcon from '@mui/icons-material/AddHome';
import DI from './utility/DI'
const Navigators = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const isMobile = useMediaQuery('(max-width:600px)');
  const {
    di: { session },
  } = props;

  const handleChange = (event, newValue) => {
    console.log({newValue});
    navigate(newValue);
  };

  return (
    <div style={{marginBottom:`10px`}} key={currentPath}>
      {isMobile ? (
        <BottomNavigation value={currentPath} onChange={handleChange} showLabels>
          <BottomNavigationAction
            label="Expenses"
            value="/panel"
            icon={<RoomIcon />}
          />
          {session?.homes?.length&&<BottomNavigationAction
            label="Expenses"
            value="/home"
            icon={<HomeIcon />}
          />}
          <BottomNavigationAction
            label="Add"
            value="/home/add"
            icon={<AddHomeIcon />}
          />
          
          <BottomNavigationAction
            label="Add"
            value="/panel/friends"
            icon={<GroupAddIcon />}
          />
        </BottomNavigation>
      ) : (
        <Tabs
          value={currentPath}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom: '10px' }}
        >
          <Tab
            label="Room Expenses"
            value="/panel"
            icon={<RoomIcon />}
            iconPosition="start"
          />
           {session?.homes?.length&&<Tab
            label="Home Expenses"
            value="/home"
            icon={<HomeIcon />}
            iconPosition="start"
          />}
          <Tab
            label="Add Home"
            value="/home/add"
            icon={<AddHomeIcon />}
            iconPosition="start"
          />
          <Tab
            label="Add Friend"
            value="/panel/friends"
            icon={<GroupAddIcon />}
            iconPosition="start"
          />
        </Tabs>
      )}
    </div>
  )
}

export default DI(Navigators)